<!-- eslint-disable i18next/no-literal-string -->
<template>
  <mc-confirmation 
    :value="true" 
    title="Batal"
    message="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor." 
    hide-header
    size="sm"
  >
    <b-list-group>
      <b-list-group-item v-for="n in 5" :key="n">Label</b-list-group-item>
    </b-list-group>
  </mc-confirmation>
</template>
<script>
  import McConfirmation from './index.vue'
export default {
  components: {
    McConfirmation
  }
}
</script>